<template>
		<div class="content">
			<div class="nav ac">
				<span class="mt20">{{$t('profile')}}</span>
			</div>
			<div class="mt20">
        <div class="fwb fw7 ac">
          <div class="name fw7 fs20">
            - {{$t('Name')}} -
          </div>
          <div class="fen">
            <span class="name-span app-en">{{info.nickname}}</span>
            <span class=" crff1d4f fs33" @click="editName">
              <img class="edit" src="static/images/edit.png" />
            </span>
          </div>
        </div>
        <div class="account-list2 fwb fw7 ac">
          <div class="name fw7 fs20">
           - {{$t('phoneNumber')}} -
          </div>
          <div class="fen fs27">
            <span class="name-span app-en fwb">{{info.mobile}}</span>
          </div>
        </div>
			</div>
		</div>
</template>
<script>
import Header from '../components/headerNo'
import Dialog from '../components/dialog'

export default {
    components:{
		Header,
    Dialog
    },
    data() {
        return {
          disAbled:'',
          edit:'Edit',
          isEdit:false,
          info:'',
          nickname:'',

        }
    },
	watch: {

	},
	computed:{
	},
    mounted() {
		let that = this;
    },
	created(){
		this.edit = this.$t('Edit')
		this.getHome();

	},
    methods: {
		back(){
			this.$router.go(-1);
		},
    editName(){
      this.$router.push({path:'/personalInfo'})
    },
		getHome(){
			let that =this;
			//that.$parent.loadModal(true);
			that.$api.post('/api/user/info',null,r =>{
				that.$parent.$parent.returnCode(r,function(){
					that.info = r.data
					that.$parent.$parent.loadModal(false);
        });

			})
		},
	}
}
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/page/myAccount.vue